import { render } from "./FinanceItem.vue?vue&type=template&id=4127f59e"
import script from "./FinanceItem.vue?vue&type=script&lang=js"
export * from "./FinanceItem.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/A06A90716A9045C6/marc/htdocs/crm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__